"use client"
import { Clear } from '@mui/icons-material';
import _ from 'lodash';
import React from 'react'

const SavedCardOption = (props) => {
    const { title, optionData, checked, _onChangeFunction, section } = props;
    return (
        <>
            {(optionData?.length > 0) ? (
                optionData?.map((data, index) => {
                    return (
                        <React.Fragment key={index + 1}>
                            <div className="radio_option relative flex w-full items-center">
                                <label className='relative flex flex-wrap w-full mb-[10px]'>
                                    <input
                                        // defaultValue={data?.amount}
                                        type='radio'
                                        checked={(section === "savedCard") ? (checked === data?.customerAccountId) : (checked === data?.paymentOptionId)}
                                        onChange={() => _onChangeFunction(data)}
                                        name={`radio-button-demo_${_.lowerCase(section)}`}
                                        className='absolute opacity-0 pointer-events-none peer'
                                    />
                                    <span className={`
                                        cursor-pointer text-[15px] text-black w-full flex py-6 px-5 border-[2px] border-clr rounded-[6px] 
                                        transition-all ease-in-out duration-300 before:content-[""] before:w-[20px] before:h-[20px] 
                                        before:border-[2px] before:border-clr before:block before:mr-[12px] before:transition-all 
                                        before:ease-in-out before:duration-300 before:rounded-[100%] after:content-[""] 
                                        after:h-[6px] after:w-[6px] after:bg-white after:absolute after:top-[33px] after:left-[29px] 
                                        after:rounded-[100%] peer-checked:before:bg-[#000000] peer-checked:before:border-[#000000] 
                                        peer-checked:bg-[#f2f2f2]`}>
                                        {(section === "savedCard") ? data?.creditCardDisplay : data?.description}
                                    </span>
                                </label>
                                {/* {(checked === data?.customerAccountId) &&
                                    <div className='cvv_section'>
                                        <Clear style={{ cursor: "pointer" }} onClick={() => _onChangeFunction(null)} />
                                    </div>
                                } */}
                            </div>

                        </React.Fragment>
                    );
                })
            ) : (
                <p>No Saved Payment Method</p>
            )}
        </>
    )
}



export default SavedCardOption;